import referAFriendImageAdversiting from "assets/images/referrals/adversiting.png";
import { HeroPropagandaItem } from "components/UI/molecules";
import { PROPAGANDA_ITEMS } from "./utils/content";
import "./index.scss";

export const ReferAFriendAdvertising = () => {
  return (
    <div className="hero-advertising-container" data-testid="hero-advertising">
      <div className="hero-image-wrapper">
        <img
          className="advertising-image"
          src={referAFriendImageAdversiting}
          alt="testimontial adversiting"
        />
      </div>

      <div className="hero-propaganda">
        {PROPAGANDA_ITEMS.map((item) => (
          <HeroPropagandaItem key={item.id} {...item} />
        ))}
      </div>
    </div>
  );
};
